import React from 'react';
import { useField } from 'formik';
import styled from 'styled-components/macro';

import { FormikErrorMessage } from './FormikErrorMessage';
import { FormikLabel } from './FormikLabel';
import { Flex, FlexProps } from '../styles/layout';

const Textarea = styled.textarea`
  width: 100%;
  height: 100px;
  padding: 8px 12px;
  min-height: 100px;
  max-height: 300px;
  border-radius: 4px;
  box-sizing: border-box;
  border: solid 1px #d0d3d9;
  &:focus {
    outline: none;
    border: solid 1px ${({ theme }) => theme.colors.neutral[40]};
  }
`;

interface CustomTextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  name: string;
  label: string;
  isRequired: boolean;
  wrapper?: FlexProps;
}

export const FormikTextAreaField = ({
  label,
  isRequired,
  wrapper,
  ...props
}: CustomTextareaProps) => {
  const [field, meta] = useField(props);
  return (
    <Flex {...wrapper} gap='4px'>
      <FormikLabel
        label={label}
        name={props.name}
        isRequired={isRequired}
        disabled={!!props.disabled}
      />
      <Textarea {...field} {...props} id={props.name} />
      <FormikErrorMessage meta={meta} />
    </Flex>
  );
};
